import type { ZodType } from 'zod';

/**
 * Validates one field against a zod schema, so a field can carry its rules inline instead of the
 * form carrying a resolver for all of them. The first issue's message becomes the field error.
 */
export const zodRule =
  (schema: ZodType) =>
  (value: unknown): true | string => {
    const result = schema.safeParse(value);

    return result.success || (result.error.issues[0]?.message ?? 'Invalid value');
  };
